/* ============================================================
   Swell Scenes — Free Print Follow Gate
   free-print-gate.js
   Mailchimp subscribe (via Cloudflare Worker) + 2-step follow gate logic
   ============================================================ */

(function () {
  'use strict';

  /* Config is injected by the liquid snippet */
  var cfg        = window.SSGateConfig || {};
  var WORKER_URL = cfg.workerUrl || '';
  var CODE       = cfg.code      || 'FREESCENE';

  /* ---- State ---- */
  var igClicked = false;

  /* ---- DOM helpers ---- */
  function $(id) { return document.getElementById(id); }

  /* ---- Public API ---- */
  window.SSGate = {

    open: function () {
      var overlay = $('ss-gate-overlay');
      if (!overlay) return;
      overlay.classList.add('ss-open');
      document.body.style.overflow = 'hidden';
      /* Focus the modal for accessibility */
      var modal = $('ss-gate-modal');
      if (modal) modal.focus();
    },

    close: function () {
      var overlay = $('ss-gate-overlay');
      if (!overlay) return;
      overlay.classList.remove('ss-open');
      document.body.style.overflow = '';
      SSGate.reset();
    },

    markIGClicked: function () {
      igClicked = true;

      /* Reveal checkbox immediately on click for desktop */
      SSGate._revealConfirmRow();

      /* Also reveal when user returns to tab after opening Instagram app on mobile */
      document.addEventListener('visibilitychange', function onReturn() {
        if (!document.hidden && igClicked) {
          SSGate._revealConfirmRow();
          document.removeEventListener('visibilitychange', onReturn);
        }
      });

      /* Fallback: reveal on window focus (some browsers use this instead) */
      window.addEventListener('focus', function onFocus() {
        if (igClicked) {
          SSGate._revealConfirmRow();
          window.removeEventListener('focus', onFocus);
        }
      });
    },

    _revealConfirmRow: function () {
      var row = $('ss-confirm-row');
      if (row) row.classList.remove('ss-confirm-hidden');
    },

    toggleCheck: function () {
      var cb  = $('ss-ig-check');
      var btn = $('ss-next-btn');
      if (!cb || !btn) return;
      btn.classList.toggle('ss-ready', cb.checked);
      btn.disabled = !cb.checked;
      btn.setAttribute('aria-disabled', cb.checked ? 'false' : 'true');
    },

    goStep2: function () {
      var cb = $('ss-ig-check');
      if (!cb || !cb.checked) return;

      $('ss-step-1').classList.remove('ss-active');
      $('ss-step-2').classList.add('ss-active');

      /* Advance progress dot */
      var pd2 = $('ss-pd-2');
      if (pd2) pd2.classList.add('ss-done');

      /* Focus email field */
      var emailInput = $('ss-email-input');
      if (emailInput) {
        setTimeout(function () { emailInput.focus(); }, 100);
      }
    },

    handleSubmit: function () {
      var emailInput = $('ss-email-input');
      var errorMsg   = $('ss-error-msg');
      var submitBtn  = $('ss-submit-btn');

      if (!emailInput) return;

      var email     = emailInput.value.trim();
      var firstName = ($('ss-first-name') || {}).value || '';
      var lastName  = ($('ss-last-name')  || {}).value || '';

      /* Clear previous errors */
      if (errorMsg) errorMsg.textContent = '';

      /* Basic validation */
      if (!firstName.trim()) {
        if (errorMsg) errorMsg.textContent = 'Please enter your first name.';
        var fn = $('ss-first-name'); if (fn) fn.focus();
        return;
      }

      if (!email) {
        if (errorMsg) errorMsg.textContent = 'Please enter your email address.';
        emailInput.focus();
        return;
      }

      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        if (errorMsg) errorMsg.textContent = 'Please enter a valid email address.';
        emailInput.focus();
        return;
      }

      /* Disable button during submission */
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.classList.add('ss-loading');
        submitBtn.textContent = 'Signing you up';
      }

      /* Subscribe via Cloudflare Worker → Mailchimp */
      SSGate._subscribeMailchimp(email, firstName.trim(), lastName.trim(), function (success, err) {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.classList.remove('ss-loading');
          submitBtn.textContent = 'Send me my free print code';
        }

        if (!success) {
          /*
           * If the Worker/Mailchimp call fails, still show the code.
           * You can tighten this by showing an error instead — swap the
           * two lines below to prevent code reveal on API failure.
           */
          console.warn('Mailchimp subscribe failed:', err);
          /* Fall through to reveal code anyway */
        }

        SSGate._revealCode();
      });
    },

    _subscribeMailchimp: function (email, firstName, lastName, callback) {
      /*
       * Calls the Cloudflare Worker proxy, which securely forwards the
       * subscription to Mailchimp's API using the secret key stored as
       * a Worker environment variable. The API key never reaches the browser.
       *
       * Worker source: worker/mailchimp-subscribe.js
       * Deploy at: https://dash.cloudflare.com → Workers → Create Worker
       */
      if (!WORKER_URL || WORKER_URL === 'YOUR_CLOUDFLARE_WORKER_URL') {
        console.warn('SSGate: No Worker URL set. Skipping Mailchimp subscribe.');
        callback(true);
        return;
      }

      fetch(WORKER_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: email,
          first_name: firstName,
          last_name: lastName,
          tags: ['free-print-gate'],
          merge_fields: {
            SOURCE: 'free_print_gate',
            IG_OPT: 'yes'
          }
        })
      })
        .then(function (res) {
          if (res.ok) {
            callback(true);
          } else {
            res.json().then(function (data) {
              callback(false, data);
            }).catch(function () {
              callback(false, 'Non-JSON error response');
            });
          }
        })
        .catch(function (err) {
          callback(false, err);
        });
    },

    _revealCode: function () {
      var codeEl = $('ss-code-value');
      if (codeEl) codeEl.textContent = CODE;

      $('ss-step-2').classList.remove('ss-active');
      $('ss-step-3').classList.add('ss-active');

      var pd3 = $('ss-pd-3b');
      if (pd3) pd3.classList.add('ss-done');

      /* Redirect to thank you page after brief delay so user sees the code */
      setTimeout(function () {
        window.location.href = '/pages/free-print-offer-thank-you';
      }, 2000);
    },

    copyCode: function () {
      var codeEl = $('ss-code-value');
      var copyBtn = $('ss-copy-btn');
      if (!codeEl) return;

      var code = codeEl.textContent;

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(function () {
          SSGate._flashCopied(copyBtn);
        }).catch(function () {
          SSGate._fallbackCopy(code, copyBtn);
        });
      } else {
        SSGate._fallbackCopy(code, copyBtn);
      }
    },

    _fallbackCopy: function (text, btn) {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.focus();
      ta.select();
      try { document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(ta);
      SSGate._flashCopied(btn);
    },

    _flashCopied: function (btn) {
      if (!btn) return;
      var original = btn.textContent;
      btn.textContent = 'Copied!';
      setTimeout(function () { btn.textContent = original; }, 2000);
    },

    reset: function () {
      /* Reset to step 1 */
      var steps = document.querySelectorAll('.ss-gate-step');
      steps.forEach(function (s) { s.classList.remove('ss-active'); });
      var step1 = $('ss-step-1');
      if (step1) step1.classList.add('ss-active');

      /* Reset checkbox */
      var cb = $('ss-ig-check');
      if (cb) cb.checked = false;

      var row = $('ss-confirm-row');
      if (row) row.setAttribute('aria-checked', 'false');

      /* Reset next button */
      var nextBtn = $('ss-next-btn');
      if (nextBtn) {
        nextBtn.classList.remove('ss-ready');
        nextBtn.disabled = true;
        nextBtn.setAttribute('aria-disabled', 'true');
      }

      /* Reset name + email fields */
      var fn = $('ss-first-name'); if (fn) fn.value = '';
      var ln = $('ss-last-name');  if (ln) ln.value = '';
      var emailInput = $('ss-email-input');
      if (emailInput) emailInput.value = '';

      /* Re-hide confirm checkbox */
      var confirmRow = $('ss-confirm-row');
      if (confirmRow) confirmRow.classList.add('ss-confirm-hidden');

      /* Clear errors */
      var errorMsg = $('ss-error-msg');
      if (errorMsg) errorMsg.textContent = '';

      /* Reset progress dots on step 2/3 panels */
      var pd2 = $('ss-pd-2');
      if (pd2) pd2.classList.remove('ss-done');
      var pd3 = $('ss-pd-3b');
      if (pd3) pd3.classList.remove('ss-done');

      igClicked = false;
    }

  };

  /* ---- Close on overlay background click ---- */
  document.addEventListener('DOMContentLoaded', function () {
    var overlay = $('ss-gate-overlay');
    if (overlay) {
      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) SSGate.close();
      });
    }

    /*
     * External trigger buttons — any button matching these selectors
     * will open the follow gate modal instead of following its default href.
     * Add or remove selectors from this array as needed.
     */
    var EXTERNAL_TRIGGERS = [
      '#ImageWithText--template--26691709501715__image_with_text_zN3waD .button',
      '.content-container--full-width.section-template--26691709501715__rich_text_U3MmNc-padding .button'
    ];

    EXTERNAL_TRIGGERS.forEach(function (selector) {
      var btns = document.querySelectorAll(selector);
      btns.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          SSGate.open();
        });
      });
    });
  });

  /* ---- Close on Escape key ---- */
  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Escape' || e.keyCode === 27)) {
      var overlay = $('ss-gate-overlay');
      if (overlay && overlay.classList.contains('ss-open')) {
        SSGate.close();
      }
    }
  });

})();
